(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("FastTrack.PaperApplication",
            {
                url: "/{transactionId}/PaperApplication",
                component: "ftPaperApplication",
                resolve: {
                    transaction: [
                        "transactionApi", "$transition$", function (transactionApi, $transition$) {
                            return transactionApi.get($transition$.params().transactionId);
                        }
                    ],
                    applicationDocuments: ["transactionDocumentApi", "$stateParams", function (transactionDocumentApi, $stateParams) {
                        return transactionDocumentApi.getTransactionDocumentsByType($stateParams.transactionId, "ApplicationDocument");
                    }],
                },
                onEnter: ["transaction", "transactionApi", function (transaction, transactionApi) {
                    transaction.LastTransactionStage = "PaperApplication";
                    transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                }]
            });
    }]);

    app.component("ftPaperApplication",
        {
            templateUrl: "/App/FastTrack/PaperApplication/template.html",
            controller: paperApplicationController,
            bindings: {
                transaction: "<",
                applicationDocuments: "<"
            }
        });

    paperApplicationController.$inject = ["$state", "$scope", "transactionApi", "_", "transactionDocumentApi", "$mdDialog", "states"];
    function paperApplicationController($state, $scope, transactionApi, _, transactionDocumentApi, $mdDialog, states) {
        var $ctrl = this;
        $ctrl.ui = {
            deleting: [],
            saving: false
        };

        ng.extend($ctrl,
            {

                uploadFiles: uploadFiles,
                uploadFunc: uploadFunc,
                sortedApplicationDocuments: [],
                name: name,
                submitApp: submitApp,
                removeDocument: removeDocument,
                states: states,
                closeDialog: closeDialog,
                submit: submit,
                endTransaction: endTransaction
            });

        function uploadFunc(file, index) {
            if (file !== null) {
                var fileName = removeExtension(file.name);
                var payload = new FormData();

                if ($ctrl.sortedApplicationDocuments.indexOf(fileName) === -1) {
                    payload.append("additionalDocument", file, file.name);
                    transactionDocumentApi.addAdditionalDocument($ctrl.transaction.Id, payload, "ApplicationDocument")
                        .then(function (response) {
                            response.FileName = fileName;
                            $ctrl.applicationDocuments.push(response);
                            //$ctrl.ui.deleting[index] = false;
                            $ctrl.ui.saving = false;
                            if ($ctrl.sortedApplicationDocuments.indexOf(response.FileName) === -1)
                                addNewDoc(response);
                        });
                }
            }
        }

        function uploadFiles(files, index) {
            $ctrl.ui.saving = true;
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    uploadFunc(files[i], index);
                }
            } else {
                uploadFunc(files, index);
            }
        }

        function removeExtension(fileName) {
            fileName = fileName.replace(/\.[^/.]+$/, "");
            return fileName;
        }

        function addNewDoc(response) {
            $ctrl.sortedApplicationDocuments.push(response);
            $ctrl.files.push(response.FileName);
        }

        function removeDocument(index, $event) {

            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to delete this document?",
                targetEvent: $event,
                ariaLabel: "Delete application document",
                ok: "Yes",
                cancel: "No",
                skipHide: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(confirm).then(function () {
                $ctrl.ui.deleting[index] = true;
                var doc = $ctrl.sortedApplicationDocuments[index];
                var fileIndex = $ctrl.files.indexOf(doc.FileName);
                var docIndex = $ctrl.applicationDocuments.indexOf(doc.FileName);

                return transactionDocumentApi.deleteDocument($ctrl.transaction.Id, doc.Id).then(function () {
                    $ctrl.sortedApplicationDocuments.splice(index, 1);
                    $ctrl.files.splice(fileIndex, 1);
                    $ctrl.applicationDocuments.splice(docIndex, 1);
                    $ctrl.ui.deleting[index] = false;
                });
            });
        };

        function submit($event) {
            //Logic to submit application needed
            closeDialog();
            $ctrl.ui.generating = true;
            updateStatus("PaperApplication", $event);
        }

        function updateStatus(status, $event) {
            $ctrl.transaction.TransactionStatus = status;
            return transactionApi.updateTransactionStatus($ctrl.transaction.Id, $ctrl.transaction).then(function () {
                $ctrl.ui.generating = false;

                //show new dialog
                var completeDialog = {
                    contentElement: "#completeDialog",
                    parent: ng.element(document.body),
                    targetEvent: $event,
                    clickOutsideToClose: false
                };

                $mdDialog.show(completeDialog);
            });
        }

        function submitApp($event) {
            var submitConfirm = {
                contentElement: "#submitDialog",
                parent: ng.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: false
            };

            $mdDialog.show(submitConfirm);
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function endTransaction() {
            $state.go("FastTrack.Initiate");
        }

        this.$onInit = function () {
            $ctrl.ui.generating = true;
            if ($ctrl.transaction.TransactionStatus !== "InProgress") {
                $state.go("FastTrack.Initiate");
            } else $ctrl.ui.generating = false;

            $ctrl.files = [];

            if ($ctrl.applicationDocuments.length) {
                ng.forEach($ctrl.applicationDocuments, function (file) {
                    file.FileName = removeExtension(file.FileName);
                    addNewDoc(file);
                });
            };
        };
    }

})(window.app, window.angular);